module.exports = __webpack_public_path__ + "img/阻力带旋转.77f26b7a.png";